import './sidebar.css'
import './web_component'
import React from 'react'
import { SidebarLayoutProps } from './types'

export const Sidebar: React.FC<SidebarLayoutProps> = ({ children, ...props }) => (
  <sidebar-l {...props}>{children}</sidebar-l>
)
